export default __webpack_public_path__ + "static/media/whatsapp-phone-img.dada56f0.png";